import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Flex, Heading, Text, VStack, HStack } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { motion } from 'framer-motion';
import { TerminalText } from './TerminalText';
import { CodeBlock } from './CodeBlock';
const MotionBox = motion(Box);
const glowKeyframes = keyframes`
  0% { box-shadow: 0 0 10px rgba(0, 153, 255, 0.5); }
  50% { box-shadow: 0 0 20px rgba(0, 153, 255, 0.8); }
  100% { box-shadow: 0 0 10px rgba(0, 153, 255, 0.5); }
`;
export function Hero() {
  const [showBio, setShowBio] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  useEffect(() => {
    // Simulate loading sequence
    const timer = setTimeout(() => {
      setShowBio(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  const handleTextComplete = () => {
    setShowButtons(true);
  };
  const bioCode = `const developer = {
  name: "George Klenam Quarshie",
  title: "Backend Developer & Security Specialist",
  expertise: ["API Security", "System Architecture", "Robotics"],
  skills: {
    backend: ["Django/DRF", "Node.js", "Python", "PostgreSQL"],
    security: ["Penetration Testing", "OWASP Standards", "Auth Systems"],
    other: ["Robotics Engineering", "STEM Education", "System Design"]
  },
  mission: "Building secure, scalable systems that solve real problems"
};
// Let's connect and build something secure together
export default developer;`;
  return <Box py={20} width="100%" position="relative" overflow="hidden" minHeight="90vh" display="flex" alignItems="center" data-id="element-188">
      {/* Animated grid background */}
      <Box position="absolute" top="0" left="0" right="0" bottom="0" bgImage="linear-gradient(rgba(10, 10, 15, 0.95), rgba(10, 10, 15, 0.95)), url('https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80')" bgSize="cover" zIndex="-1" data-id="element-189" />
      {/* Digital circuit lines */}
      <Box position="absolute" top="0" left="0" right="0" bottom="0" opacity="0.15" zIndex="-1" bgImage="url('https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80')" bgSize="cover" bgPosition="center" bgRepeat="no-repeat" data-id="element-190" />
      <Container maxW="1200px" zIndex="1" data-id="element-191">
        <Flex align="center" direction={{
        base: 'column',
        lg: 'row'
      }} gap={{
        base: 12,
        lg: 8
      }} data-id="element-192">
          <VStack flex="1" align="flex-start" spacing={6} data-id="element-193">
            <MotionBox initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 1
          }} data-id="element-194">
              <TerminalText text="$ whoami" typingSpeed={80} cursorColor="#00ff85" fontSize="1.2rem" data-id="element-195" />
            </MotionBox>
            <MotionBox initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 1,
            delay: 1
          }} data-id="element-196">
              <Heading as="h1" fontSize={{
              base: '3xl',
              md: '5xl'
            }} fontWeight="bold" lineHeight="shorter" bgGradient="linear(to-r, neonBlue.400, neonPurple.400)" bgClip="text" fontFamily="mono" data-id="element-197">
                George Klenam Quarshie
              </Heading>
            </MotionBox>
            <MotionBox initial={{
            opacity: 0
          }} animate={{
            opacity: showBio ? 1 : 0
          }} transition={{
            duration: 0.5
          }} data-id="element-198">
              <TerminalText text="Backend Developer | Security Specialist | Robotics Engineer" typingSpeed={30} startDelay={1500} fontSize="xl" textColor="neonGreen.400" onComplete={handleTextComplete} data-id="element-199" />
            </MotionBox>
            {showButtons && <MotionBox initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-200">
                <HStack spacing={4} mt={4} data-id="element-201">
                  <Button as="a" href="#projects" variant="solidNeon" size="lg" fontFamily="mono" fontWeight="medium" boxShadow="0 0 15px rgba(0, 153, 255, 0.5)" _hover={{
                boxShadow: '0 0 20px rgba(0, 153, 255, 0.8)'
              }} data-id="element-202">
                    view_projects()
                  </Button>
                  <Button as="a" href="#contact" variant="neonGreen" size="lg" fontFamily="mono" fontWeight="medium" _hover={{
                boxShadow: '0 0 15px rgba(0, 255, 133, 0.5)'
              }} data-id="element-203">
                    contact_me()
                  </Button>
                </HStack>
              </MotionBox>}
          </VStack>
          <MotionBox flex="1" initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} data-id="element-204">
            <Box borderRadius="lg" overflow="hidden" animation={`${glowKeyframes} 3s infinite ease-in-out`} data-id="element-205">
              <CodeBlock code={bioCode} language="javascript" data-id="element-206" />
            </Box>
          </MotionBox>
        </Flex>
      </Container>
    </Box>;
}